// extracted by mini-css-extract-plugin
export var button = "_dj-7";
export var buttonRow = "_dj-6";
export var fadeIn = "_dj-1";
export var gradient = "_dj-0";
export var panel = "_dj-2";
export var panelIn = "_dj-3";
export var subtitle = "_dj-5";
export var title = "_dj-4";